"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var axios_1 = __importDefault(require("axios"));
var STORAGE_KEY = 'sms_verification_data';
var SmsVerificationStore = /** @class */ (function () {
    function SmsVerificationStore(props) {
        if (props === void 0) { props = {}; }
        var _this = this;
        this.phoneNumber = '';
        this.verificationCode = '';
        this.token = null;
        this.isLoading = false;
        this.errors = null;
        this.isModalOpen = false;
        this.isVerified = false;
        this.otpRequested = false;
        this.isResent = false;
        this.resendCooldownSeconds = 0;
        this.autoSubmitRequested = false;
        this.resendCooldownTimer = null;
        this.sendCodeRequest = null;
        this.prepareForPhoneNumber = function (phoneNumber) {
            if (_this.phoneNumber === phoneNumber)
                return;
            _this.sendCodeRequest = null;
            _this.phoneNumber = phoneNumber;
            _this.verificationCode = '';
            _this.errors = null;
            _this.isVerified = false;
            _this.otpRequested = false;
            _this.isResent = false;
            _this.autoSubmitRequested = false;
            _this.clearResendCooldown();
        };
        this.sendCode = function (phoneNumber) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.sendCodeRequest) {
                            return [2 /*return*/, this.sendCodeRequest];
                        }
                        this.sendCodeRequest = this.performSendCode(phoneNumber);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.sendCodeRequest];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        this.sendCodeRequest = null;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.performSendCode = function (phoneNumber) { return __awaiter(_this, void 0, Promise, function () {
            var storedPhoneNumber, response, alreadyVerified, newToken_1, newToken, error_1, errorToken;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        this.isLoading = true;
                        this.errors = null;
                        this.autoSubmitRequested = false;
                        storedPhoneNumber = this.getStoredPhoneNumber();
                        if (!this.token || storedPhoneNumber !== phoneNumber) {
                            this.token = this.generateToken();
                            this.saveToStorage(phoneNumber, this.token);
                        }
                        this.phoneNumber = phoneNumber;
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post('/api/sms_verifications/send_otp', {
                                sms_verification: {
                                    phone_number: phoneNumber,
                                    token: this.token
                                }
                            }, {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            })];
                    case 2:
                        response = _m.sent();
                        alreadyVerified = ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.alreadyVerified) === true;
                        if (response.data.version === 'v1') {
                            if (alreadyVerified) {
                                newToken_1 = (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.token;
                                if (newToken_1) {
                                    this.token = newToken_1;
                                    this.saveToStorage(phoneNumber, newToken_1);
                                }
                                this.isVerified = true;
                                this.autoSubmitRequested = true;
                                this.isModalOpen = false;
                                this.otpRequested = false;
                                this.isResent = false;
                                this.isLoading = false;
                                return [2 /*return*/, true];
                            }
                            newToken = (_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.token;
                            if (newToken) {
                                this.token = newToken;
                                this.saveToStorage(phoneNumber, newToken);
                            }
                            this.startResendCooldown();
                            this.otpRequested = true;
                            this.isResent = false;
                            this.isVerified = false;
                            this.autoSubmitRequested = false;
                            this.isLoading = false;
                            return [2 /*return*/, true];
                        }
                        throw new Error('Failed to send SMS');
                    case 3:
                        error_1 = _m.sent();
                        this.errors = ((_h = (_g = error_1.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) || 'SMS送信に失敗しました';
                        this.isLoading = false;
                        this.autoSubmitRequested = false;
                        this.isVerified = false;
                        errorToken = (_l = (_k = (_j = error_1.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.token;
                        if (errorToken) {
                            this.token = errorToken;
                            this.saveToStorage(this.phoneNumber, errorToken);
                        }
                        this.startResendCooldown();
                        this.otpRequested = true;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.verifyCode = function () { return __awaiter(_this, void 0, Promise, function () {
            var response, error_2, messages;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.verificationCode.length !== 6) {
                            this.errors = '認証コードは6桁で入力してください';
                            return [2 /*return*/, false];
                        }
                        if (!this.phoneNumber) {
                            this.errors = '認証情報が不正です';
                            return [2 /*return*/, false];
                        }
                        if (!this.token) {
                            this.errors = '認証情報が不正です';
                            return [2 /*return*/, false];
                        }
                        this.isLoading = true;
                        this.errors = null;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post('/api/sms_verifications/verify', {
                                sms_verification: {
                                    phone_number: this.phoneNumber,
                                    otp: this.verificationCode,
                                    token: this.token
                                }
                            }, {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            })];
                    case 2:
                        response = _c.sent();
                        if (response.data.version === 'v1') {
                            this.isLoading = false;
                            this.isModalOpen = false;
                            this.isVerified = true;
                            this.autoSubmitRequested = false;
                            return [2 /*return*/, true];
                        }
                        else {
                            throw new Error('Invalid verification code');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _c.sent();
                        messages = (_b = (_a = error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
                        if (messages) {
                            this.errors = messages;
                        }
                        else {
                            this.errors = ['入力された認証コードが異なります。', 'お手元のSMSに記載された6桁のコードを再度ご確認ください。'];
                        }
                        // Clear input and reset state on verification failure
                        this.verificationCode = '';
                        this.isLoading = false;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.resendCode = function () { return __awaiter(_this, void 0, Promise, function () {
            var response, alreadyVerified, newToken_2, newToken, error_3, errorToken;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        if (!this.phoneNumber) {
                            this.errors = '電話番号が設定されていません';
                            return [2 /*return*/, false];
                        }
                        this.isLoading = true;
                        this.errors = null;
                        this.verificationCode = '';
                        this.isResent = true;
                        this.autoSubmitRequested = false;
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post('/api/sms_verifications/send_otp', {
                                sms_verification: {
                                    phone_number: this.phoneNumber,
                                    token: this.token
                                }
                            }, {
                                headers: {
                                    'X-Requested-With': 'XMLHttpRequest'
                                }
                            })];
                    case 2:
                        response = _m.sent();
                        alreadyVerified = ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.alreadyVerified) === true;
                        if (response.data.version === 'v1') {
                            if (alreadyVerified) {
                                newToken_2 = (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.token;
                                if (newToken_2) {
                                    this.token = newToken_2;
                                    this.saveToStorage(this.phoneNumber, newToken_2);
                                }
                                this.isVerified = true;
                                this.autoSubmitRequested = true;
                                this.isModalOpen = false;
                                this.otpRequested = false;
                                this.isResent = false;
                                this.isLoading = false;
                                return [2 /*return*/, true];
                            }
                            newToken = (_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.token;
                            if (newToken) {
                                this.token = newToken;
                                this.saveToStorage(this.phoneNumber, newToken);
                            }
                            this.startResendCooldown();
                            this.otpRequested = true;
                            this.isResent = true;
                            this.isVerified = false;
                            this.autoSubmitRequested = false;
                            this.isLoading = false;
                            return [2 /*return*/, true];
                        }
                        throw new Error('Failed to resend SMS');
                    case 3:
                        error_3 = _m.sent();
                        this.errors = ((_h = (_g = error_3.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) || 'SMS再送に失敗しました';
                        this.isLoading = false;
                        this.autoSubmitRequested = false;
                        this.isVerified = false;
                        this.isResent = true;
                        errorToken = (_l = (_k = (_j = error_3.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.token;
                        if (errorToken) {
                            this.token = errorToken;
                            this.saveToStorage(this.phoneNumber, errorToken);
                        }
                        this.startResendCooldown();
                        this.otpRequested = true;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.setVerificationCode = function (code) {
            _this.verificationCode = code;
            _this.errors = null;
        };
        this.closeModal = function () {
            _this.verificationCode = '';
            _this.errors = null;
            _this.isModalOpen = false;
            _this.isLoading = false;
        };
        this.completeAutoSubmitRequest = function () {
            _this.autoSubmitRequested = false;
            _this.isModalOpen = false;
            _this.verificationCode = '';
            _this.errors = null;
            _this.isLoading = false;
        };
        this.startResendCooldown = function () {
            _this.clearResendCooldown();
            _this.resendCooldownSeconds = 30;
            // Start interval that decrements every second
            _this.resendCooldownTimer = setInterval(function () {
                (0, mobx_1.runInAction)(function () {
                    if (_this.resendCooldownSeconds > 0) {
                        _this.resendCooldownSeconds -= 1;
                    }
                    else {
                        // Cooldown finished, clear the timer
                        _this.clearResendCooldown();
                    }
                });
            }, 1000);
        };
        this.clearResendCooldown = function () {
            if (_this.resendCooldownTimer !== null) {
                clearInterval(_this.resendCooldownTimer);
                _this.resendCooldownTimer = null;
            }
            _this.resendCooldownSeconds = 0;
        };
        this.loadFromStorage();
    }
    SmsVerificationStore.prototype.loadFromStorage = function () {
        if (typeof window === 'undefined')
            return;
        try {
            var stored = localStorage.getItem(STORAGE_KEY);
            if (!stored)
                return;
            var data = JSON.parse(stored);
            if (data.token) {
                this.token = data.token;
            }
        }
        catch (error) {
            // Invalid stored data, clear it
            this.clearStorage();
        }
    };
    SmsVerificationStore.prototype.getStoredPhoneNumber = function () {
        if (typeof window === 'undefined')
            return null;
        try {
            var stored = localStorage.getItem(STORAGE_KEY);
            if (!stored)
                return null;
            var data = JSON.parse(stored);
            return data.phoneNumber || null;
        }
        catch (error) {
            return null;
        }
    };
    SmsVerificationStore.prototype.saveToStorage = function (phoneNumber, token) {
        if (typeof window === 'undefined')
            return;
        try {
            var data = {
                phoneNumber: phoneNumber,
                token: token
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        }
        catch (error) {
            // Storage might be full or disabled, ignore
        }
    };
    SmsVerificationStore.prototype.clearStorage = function () {
        if (typeof window === 'undefined')
            return;
        try {
            localStorage.removeItem(STORAGE_KEY);
        }
        catch (error) {
            // Ignore
        }
    };
    SmsVerificationStore.prototype.generateToken = function () {
        var array = new Uint8Array(16);
        crypto.getRandomValues(array);
        return Array.from(array, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    };
    Object.defineProperty(SmsVerificationStore.prototype, "formattedPhoneNumber", {
        get: function () {
            if (!this.phoneNumber)
                return '';
            var cleaned = this.phoneNumber.replace(/\D/g, '');
            if (cleaned.length >= 11) {
                return "".concat(cleaned.slice(0, 3), "-").concat(cleaned.slice(3, 7), "-").concat(cleaned.slice(7));
            }
            return this.phoneNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SmsVerificationStore.prototype, "canSubmit", {
        get: function () {
            return this.verificationCode.length === 6 && !this.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SmsVerificationStore.prototype, "canResend", {
        get: function () {
            return this.resendCooldownSeconds === 0 && !this.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SmsVerificationStore.prototype, "resendButtonText", {
        get: function () {
            if (this.resendCooldownSeconds > 0) {
                return "SMS\u3092\u518D\u9001 (".concat(this.resendCooldownSeconds, "\u79D2)");
            }
            return 'SMSを再送';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "phoneNumber", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "verificationCode", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "token", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "errors", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "isModalOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "isVerified", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "otpRequested", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], SmsVerificationStore.prototype, "isResent", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "resendCooldownSeconds", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "autoSubmitRequested", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "prepareForPhoneNumber", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "sendCode", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "verifyCode", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "resendCode", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "setVerificationCode", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "closeModal", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "completeAutoSubmitRequest", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "startResendCooldown", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SmsVerificationStore.prototype, "clearResendCooldown", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SmsVerificationStore.prototype, "formattedPhoneNumber", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SmsVerificationStore.prototype, "canSubmit", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SmsVerificationStore.prototype, "canResend", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SmsVerificationStore.prototype, "resendButtonText", null);
    return SmsVerificationStore;
}());
exports.default = SmsVerificationStore;
